import React from 'react';
import { SkeletonTable } from '../../../../components/Skeleton/Table';

export const SchedulerLoading: React.FC = () => (
  <div className="p-3 d-flex flex-column gap-3">
    <SkeletonTable columns={8} rows={10} />
  </div>
);
